import React, { useEffect } from 'react';
import Breadcrumbs, { Breadcrumb } from 'components/common/Breadcrumb';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row, Skeleton } from 'antd';
import Text from 'antd/lib/typography/Text';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getTopicList, selectTopic } from 'app/slice/topicSlice';
import { range } from 'lodash';
import { NotificationType } from 'enums';

const breadcrumbs: Breadcrumb[] = [
    {
        name: 'トップページ',
        url: '/kisoku',
    },
    {
        name: '就業規則に関連するトピックス',
        url: '/kisoku/topics',
    },
];

const WorkRegulationTopicList = () => {
    const dispatch = useAppDispatch();
    const { data, loading } = useAppSelector(selectTopic);

    useEffect(() => {
        dispatch(getTopicList({
            type: NotificationType.KISOKU,
            perPage: 50,
        }));
    }, [dispatch]);

    return (
        <>
            <section className='breadcrumbs'>
                <Breadcrumbs breadcrumb={breadcrumbs} />
            </section>

            <section className='primary-content topic-list'>
                <Text className='title'>就業規則に関連するトピックス</Text>
                <div className='topics'>
                    {loading ? (
                        <div className='my-3'>
                            {range(0, 5).map(key => (
                                <Skeleton.Button key={key} active size='large' block className='mb-2' />
                            ))}
                        </div>
                    ) : data.map((topic, key) => (
                        <Card size='small' key={key}>
                            <Row>
                                <Col md={3} xs={24} className='topic-date-col'>
                                    <div className='topic-date-container'>{topic.sendDateList}</div>
                                </Col>
                                <Col md={18} xs={24} className='topic-text-col'>
                                    {topic.title}
                                </Col>
                                <Col md={3} xs={24} className='topic-button-col'>
                                    <Link to={`/kisoku/topics/${topic.uuid}`}>
                                        <Button className='secondary small'>詳細</Button>
                                    </Link>
                                </Col>
                            </Row>
                        </Card>
                    ))}
                </div>
            </section>
        </>
    );
};

export default WorkRegulationTopicList;
